export const environment = {
    prod: false,
    stage: true,
    test: false,
    devMode: false,
    allowedCloudLogHosts: ["stage.vitu.com", "stage2.vitu.com", "stage-mada.vitu.com"],
    madaHost: "stage-mada.vitu.com",
    gtagId: "G-SKJD5J5Z00",
    autoPrintAppInstallUrl: "https://stage.vitu.com/vitu-auto-print/MVSC.VituAutoPrint.Launcher.WPF.application",
    autoPrintAppUrl: "http://localhost:4799",
    // Dynamsoft Web TWAIN scanner licence: the same key everywhere, validated offline by the SDK.
    scannerProductKey: "f0068ZQAAAMsmMH/JG7kUitWSYcUsP/WX+gcGuNtrbEGsh37c3qdjgAdoTXnH70JbR7a3iRY6/xKu6W0Ek1jq1/QY0kcfs4M=",
    liveUrl: "https://stage.vitu.com",
};
